import { Button, Card, Icon, Message } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import isPendingApproval from "astrid-firestore/src/api/approval/isPendingApproval";

import Flex from "../../../../../components/Flex/Flex";
import AgreementDropdownMenu from "../../../../agreements/components/AgreementDropdownMenu/AgreementDropdownMenu";
import useAgreementDownloadURL from "../../../../agreements/hooks/useAgreementDownloadURL";
import { getAgreementSecondPartyAdminURL } from "../../../../agreements/utils/agreementsHelper";

export default function AdminAgreementInfo({ agreement }) {
	const { t } = useTranslation();

	const [signedAgreementUrl] = useAgreementDownloadURL({ agreement });

	return (
		<Card fluid>
			<Card.Content>
				{isPendingApproval(agreement) && (
					<Message info>{t("waitingForApproval", "Waiting for approval")}</Message>
				)}

				<Flex>
					<div>
						<Card.Header as="h3" style={{ marginBottom: 0 }}>
							{agreement.name}
						</Card.Header>

						<Card.Description>
							<Link to={getAgreementSecondPartyAdminURL(agreement)}>{agreement.secondParty?.name}</Link>
						</Card.Description>
					</div>

					<div>
						<AgreementDropdownMenu agreement={agreement} hideViewOption />
					</div>
				</Flex>
			</Card.Content>

			{signedAgreementUrl && (
				<Card.Content extra>
					<Button icon as="a" target="_blank" href={signedAgreementUrl} labelPosition="left">
						<Icon name="file" />
						{t("signedDocument", "Signed document")}
					</Button>
				</Card.Content>
			)}

			{agreement.template && (
				<Card.Content>
					<Card.Description>
						<strong>{t("template", "Template")}:</strong>{" "}
						<Link
							to={`/producer/${agreement.producer.id}/finance/agreements/templates/${agreement.template.id}`}
						>
							{agreement.template.name}
						</Link>
					</Card.Description>
				</Card.Content>
			)}

			<Card.Content extra>
				<Card.Description>
					<strong>{t("created", "Created")}:</strong> {agreement.created?.toDate?.().toLocaleString()}
					<br />
					<strong>{t("expires", "Expires")}:</strong> {agreement.expires?.toDate?.().toLocaleString()}
				</Card.Description>
			</Card.Content>
		</Card>
	);
}
